<template>
  <div class="cts_box" v-if="isFreeUser()">
    <h2 class="min_ttl"><span>{{ withdrawalName() }}からの退会はこちらからお手続きください。</span></h2>
    <router-link :to="{ name: 'UsersCustomerWithdrawal' }" class="link_txt">{{ withdrawalName() }}からの退会について</router-link>
  </div>
  <div class="cts_box" v-else>
    <h2 class="min_ttl"><span>{{ withdrawalName() }}からの退塾はこちらからお手続きください。</span></h2>
    <router-link :to="{ name: 'UsersCustomerWithdrawal' }" class="link_txt">{{ withdrawalName() }}からの退塾について</router-link>
  </div>
</template>

<script>
import Libraries from "@/components/Libraries.vue";

export default {
  mixins: [Libraries],
  methods: {
    withdrawalName() {
      return this.isFreeUser() ? "ゲストユーザー" : "複眼経済塾";
    },
  },
};
</script>